<template>
  <div
    v-if="value.id != null"
    class="w-full d-flex flex-row items-end align-center"
  >
    <OSimpleDialog
      ref="dialog"
      title="ClientHistory"
      :subtitle="subtitle"
      :show-buttons="false"
    >
      <pre class="pa-3 maxh-4" style="font-size: 12px">{{ str }}</pre>
    </OSimpleDialog>
    <v-spacer />
    <small>
      {{ lastAction }} por <code>{{ value.login }}</code> em
      {{ value.updatedAt | moment('DD/MM/YYYY HH:mm') }}
    </small>
    <v-btn x-small icon @click="openDialog">
      <v-icon x-small>mdi-code-braces</v-icon>
    </v-btn>

    <!-- <OCapCont class="w-1/3" label="Criado">
      {{ value.createdAt | moment('DD/MM/YYYY HH:mm') }}
    </OCapCont>
    <OCapCont class="w-1/3" label="Alterado">
      {{ value.updatedAt | moment('DD/MM/YYYY HH:mm') }}
    </OCapCont>
    <OCapCont class="w-1/3" label="Login">
      {{ value.login }}
    </OCapCont> -->
  </div>
</template>

<script>
import OSimpleDialog from 'oderon-vue/cpts/dialogs/OSimpleDialog.vue'

export default {
  components: { OSimpleDialog },
  props: {
    value: { required: true }
  },
  computed: {
    lastAction() {
      if (this.value == null) return null
      if (this.value.createdAt == this.value.updatedAt) return 'Criado'
      return 'Atualizado'
    },
    subtitle() {
      if (this.value == null) return ''
      return '#' + this.value.id
    },
    str() {
      return JSON.stringify(this.value, null, ' ')
    }
  },
  methods: {
    openDialog() {
      this.$refs.dialog.open()
    }
  }
}
</script>

<style></style>
